module.exports = __webpack_public_path__ + "img/20210627_121154.e7f2b33f.jpg";